import { render, staticRenderFns } from "./ResetPasswordCancelComponent.vue?vue&type=template&id=e6326b78&scoped=true&"
import script from "./ResetPasswordCancelComponent.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordCancelComponent.vue?vue&type=script&lang=js&"
import style0 from "./ResetPasswordCancelComponent.vue?vue&type=style&index=0&id=e6326b78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6326b78",
  null
  
)

export default component.exports